import AboutPage from "./pages/AboutPage";
import ChooseUsPage from "./pages/ChooseUsPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import SubscribePage from "./pages/SubscribePage";
import TeamPage from "./pages/TeamPage";
import ValuesPage from "./pages/ValuesPage";

function App() {
  return (
    <>
      <HomePage id="home"/>
      <AboutPage id="about" />
      <ChooseUsPage id="choose-us" />
      <ValuesPage id="values" />
      <TeamPage id="team" />
      <ContactPage id="contact" />
      <SubscribePage id="subscribe" />
    </>
  );
}

export default App;